import React, { useEffect, useState } from "react";
import Breadcrumb from "../../../component/breadcrumb/Breadcrumb";
import { useParams } from "react-router-dom";
import config from "../../../config";
import { triggerNotification } from "../../../component/message/Msg";
import Spinner from "../../../component/loadingbar/Spinner";

const SalesAdminProfile = () => {
  const { id } = useParams();
  const token = config.token;
  const [loading, setLoading] = useState(false);
  const [profileData, setProfileData] = useState({});

  //---------------------------------------- get / read employee -------------------------------------------R
  const fetchProfileData = async () => {
    setLoading(true);
    try {
      await fetch(`${config.host_url}sales/0`, {
        method: "GET",
        headers: {
          token: token,
        },
      })
        .then((response) => response.json())
        .then(async (data) => {
          if (data.status === 200) {
            const responseData = data.data;
            await setProfileData(responseData);
          }
        });
    } catch (error) {
      triggerNotification("error", "Error occurs in fetch data.");
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    fetchProfileData(id);
  }, [token]);

  return (
    <>
      <Breadcrumb txt="Account Settings" subpath={["My Profile "]} />

      {loading ? (
        <Spinner />
      ) : (
        <div className="container-xxl flex-grow-1 container-p-y mt-12">
          <div className="row">
            <div className="col-12">
              <div className="card mb-4">
                <div className="user-profile-header d-flex flex-column flex-sm-row text-sm-start text-center mb-4">
                  <div className="flex-shrink-0 mt-n2 mx-sm-0 mx-auto">
                    <img
                      src={profileData?.profile}
                      alt="employee image"
                      className="d-block h-[7.5rem] ms-0 ms-sm-4 border-white rounded user-profile-img"
                    />
                  </div>
                  <div className="flex-grow-1 mt-3 mt-sm-5">
                    <div className="d-flex align-items-md-end align-items-sm-start align-items-center justify-content-md-between justify-content-start mx-4 flex-md-row flex-column gap-4">
                      <div className="user-profile-info">
                        <h4>
                          {profileData?.first_name +
                            " " +
                            profileData?.last_name}
                        </h4>
                        <ul className="list-inline mb-0 d-flex align-items-center flex-wrap justify-content-sm-start justify-content-center gap-2">
                          <li className="list-inline-item">
                            <i className="mdi mdi-account  form-icon me-1 mdi-20px"></i>
                            <span className="fw-medium">
                              {profileData?.username}
                            </span>
                          </li>
                          <li className="list-inline-item">
                            <i className="mdi mdi-map-marker-outline me-1 mdi-20px"></i>
                            <span className="fw-medium">
                              {profileData?.address}
                            </span>
                          </li>
                          <li className="list-inline-item">
                            <i className="mdi mdi-calendar-blank-outline me-1 mdi-20px"></i>
                            <span className="fw-medium">
                              Joined{" "}
                              {profileData?.hiredate &&
                                profileData?.hiredate.split("T")[0]}
                            </span>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="card mb-4">
            <div className="card-body row">
              <div className="col-md-6">
                <small className="card-text text-uppercase">About</small>
                <ul className="list-unstyled my-3 py-1">
                  <li className="d-flex align-items-center mb-3">
                    <i className="mdi mdi-account-outline mdi-24px"></i>
                    <span className="fw-medium mx-2">Full Name:</span>{" "}
                    <span>
                      {profileData?.first_name + " " + profileData?.last_name}
                    </span>
                  </li>
                  <li className="d-flex align-items-center mb-3">
                    <i className="mdi mdi-account-tie-outline mdi-24px"></i>
                    <span className="fw-medium mx-2">Employee Type:</span>{" "}
                    <span>{profileData?.sales_emp_type}</span>
                  </li>
                  <li className="d-flex align-items-center mb-3">
                    <i className="mdi mdi-gift-outline mdi-24px"></i>
                    <span className="fw-medium mx-2">Incentive:</span>{" "}
                    <span>{profileData?.incentive}</span>
                  </li>
                  <li className="d-flex align-items-center mb-3">
                    <i className="mdi mdi-account-group-outline mdi-24px"></i>
                    <span className="fw-medium mx-2">
                      Parent employee:
                    </span>{" "}
                    <span>
                      {profileData?.perent_first_name +
                        " " +
                        profileData?.perent_first_name}
                    </span>
                  </li>
                  <li className="d-flex align-items-center mb-3">
                    <i className="mdi mdi-map-marker-outline mdi-24px"></i>
                    <span className="fw-medium mx-2">Address:</span>{" "}
                    <span>{profileData?.address}</span>
                  </li>
                  <li className="d-flex align-items-center mb-3">
                    <i className="mdi mdi-cake mdi-24px"></i>
                    <span className="fw-medium mx-2">DOB:</span>{" "}
                    <span>
                      {profileData?.hiredate && profileData?.dob.split("T")[0]}
                    </span>
                  </li>
                </ul>
              </div>
              <div className="col-md-6">
                <small className="card-text text-uppercase">Contacts</small>
                <ul className="list-unstyled my-3 py-1">
                  <li className="d-flex align-items-center mb-3">
                    <i className="mdi mdi-phone-outline mdi-24px"></i>
                    <span className="fw-medium mx-2">Contact:</span>{" "}
                    <span>{profileData?.mobile_no}</span>
                  </li>
                  <li className="d-flex align-items-center mb-3">
                    <i className="mdi mdi-email-outline mdi-24px"></i>
                    <span className="fw-medium mx-2">Email:</span>{" "}
                    <span>{profileData?.email}</span>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default SalesAdminProfile;
